import React, { useCallback, useState } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import BasicTextField from "../../shared/BasicTextField";
import adhocAgreementsService from "../../../services/AdhocAgreementsService";

interface NewAdhocProjectFormProps {
  onError: (error: string) => void;
  onSuccess: () => void;
}

const NewAdhocProjectForm: React.FC<NewAdhocProjectFormProps> = ({
  onError,
  onSuccess
}) => {
  const [projectName, setProjectName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      setLoading(true);
      const submit = async () => {
        try {
          const response = await adhocAgreementsService.createAdhocProject({
            name: projectName
          });
          console.log("response: ", response);

          setProjectName("");
          onSuccess();
        } catch (err) {
          console.log("err: ", err);
          onError(err as string);
        }
      };

      submit();

      setLoading(false);
    },
    [projectName, onSuccess]
  );

  return (
    <Box flexDirection="column" flex={1} marginLeft={6}>
      <Typography variant="h5">New Project</Typography>

      <form onSubmit={e => handleSubmit(e)}>
        <Box pb={1} display="flex" flexDirection="column">
          <Typography variant="overline">Project Name</Typography>
          <BasicTextField
            disabled={loading}
            handleChange={e => setProjectName(e.currentTarget.value)}
            value={projectName}
          />
        </Box>
        <Box display="flex" flexDirection="row" justifyContent="flex-end">
          <Button
            variant="contained"
            color="primary"
            disabled={loading}
            type="submit"
          >
            New Project
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default NewAdhocProjectForm;
